export default __webpack_public_path__ + "static/media/landscape5.62c7e833.JPG";